import React from "react";
import LoginForm from "../Component/Login/LoginForm";
const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
